export const teamData = {
  leadership: [
    {
      id: 1,
      name: 'Dr. Anya Sharma',
      role: 'Founder & Director',
      image: 'https://via.placeholder.com/300x300.png?text=Dr.Anya+Sharma', // Replace with actual image path
      bio: 'Dr. Sharma is a renowned social scientist with over 20 years of experience in development research and policy advocacy. Her work focuses on poverty alleviation and gender equality.',
      linkedin: 'https://linkedin.com/in/anyasharma', // Replace with actual URL
      twitter: 'https://twitter.com/anyasharma', // Replace with actual URL
      instagram: 'https://instagram.com/anyasharma',
      whatsapp: 'https://wa.me/919876543210',
    },
    {
      id: 2,
      name: 'Mr. Rohan Verma',
      role: 'Head of Programs & Operations',
      image: 'https://via.placeholder.com/300x300.png?text=Mr.Rohan+Verma', // Replace
      bio: 'Mr. Verma brings extensive expertise in project management and strategic planning, ensuring the effective implementation of InSocia\'s initiatives across various sectors.',
      linkedin: 'https://linkedin.com/in/rohanverma',
      twitter: 'https://twitter.com/rohanverma',
      instagram: 'https://instagram.com/rohanverma',
      whatsapp: 'https://wa.me/919876543211',
    },
    // Add more leadership team members
  ],
  advisoryBoard: [
    {
      id: 3,
      name: 'Prof. Elena Petrova',
      role: 'Senior Advisor, International Development',
      image: 'https://via.placeholder.com/300x300.png?text=Prof.Elena+Petrova', // Replace
      bio: 'Professor Petrova is an expert in global development strategies and has advised numerous international organizations on sustainable practices.',
      affiliation: 'Global Policy Institute',
      linkedin: 'https://linkedin.com/in/elenapetrova',
      twitter: 'https://twitter.com/elenapetrova',
      instagram: 'https://instagram.com/elenapetrova',
      whatsapp: 'https://wa.me/919876543212',
    },
    {
      id: 4,
      name: 'Dr. Kenji Tanaka',
      role: 'Advisor, Health & Technology',
      image: 'https://via.placeholder.com/300x300.png?text=Dr.Kenji+Tanaka', // Replace
      bio: 'Dr. Tanaka specializes in leveraging technology for health system strengthening and has pioneered several innovative healthcare solutions in developing countries.',
      affiliation: 'TechForHealth Initiative',
      linkedin: 'https://linkedin.com/in/kenjitanaka',
      twitter: 'https://twitter.com/kenjitanaka',
      instagram: 'https://instagram.com/kenjitanaka',
      whatsapp: 'https://wa.me/919876543213',
    },
    // Add more advisory board members
  ],
  researchAssociates: [
    {
      id: 5,
      name: 'Ms. Priya Singh',
      role: 'Senior Research Associate',
      image: 'https://via.placeholder.com/300x300.png?text=Ms.Priya+Singh', // Replace
      bio: 'Priya focuses on qualitative research methodologies and has extensive experience in community-based studies related to education and livelihoods.',
      specialization: 'Education & Livelihoods',
      linkedin: 'https://linkedin.com/in/priyasingh',
      twitter: 'https://twitter.com/priyasingh',
      instagram: 'https://instagram.com/priyasingh',
      whatsapp: 'https://wa.me/919876543214',
    },
    {
      id: 6,
      name: 'Mr. David Lee',
      role: 'Research Associate, Data Analytics',
      image: 'https://via.placeholder.com/300x300.png?text=Mr.David+Lee', // Replace
      bio: 'David is skilled in quantitative data analysis and impact evaluation, contributing to the evidence base of InSocia\'s projects.',
      specialization: 'Data Science for Social Good',
      linkedin: 'https://linkedin.com/in/davidlee',
      twitter: 'https://twitter.com/davidlee',
      instagram: 'https://instagram.com/davidlee',
      whatsapp: 'https://wa.me/919876543215',
    },
    // Add more research associates
  ],
  projectManagers: [
    {
      id: 7,
      name: 'Ms. Fatima Khan',
      role: 'Lead Project Manager',
      image: 'https://via.placeholder.com/300x300.png?text=Ms.Fatima+Khan', // Replace
      bio: 'Fatima oversees a portfolio of projects in environmental sustainability and rural development, ensuring they meet their objectives and deliver lasting impact.',
      focus: 'Environmental Sustainability',
      linkedin: 'https://linkedin.com/in/fatimakhan',
      twitter: 'https://twitter.com/fatimakhan',
      instagram: 'https://instagram.com/fatimakhan',
      whatsapp: 'https://wa.me/919876543216',
    },
    // Add more project managers
  ],
}; 